import { useState } from 'react';
import { Spin, Alert } from 'antd';
import { useParams } from 'react-router-dom';
import { useCandidateData } from '../hooks/useCandidateData';
import CandidateHeader from '../components/cards/CandidateHeader';
import CandidateActivitySection from '../components/sections/CandidateActivitySection';
import OwnershipHistoryModal from '../components/cards/OwnershipHistoryModal';
import { useSelector } from 'react-redux';


function CandidatePage() {
    const [ownershipLogVisible, setOwnershipLogVisible] = useState(false);
    const { id } = useParams();

		const company = useSelector((state) => state.user.currentUser.company);
		const brandColor = company?.brandColor;
		const companyId = company?.id;

    const { loading, error, candidate } = useCandidateData(id, companyId);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (error) {
        return (
            <Alert
                message="Error Loading Candidate Data"
                description={error.message}
                type="error"
                showIcon
                style={{ margin: '20px' }}
            />
        );
    }

    if (!candidate) {
        return <Alert message="No candidate data found" type="warning" showIcon style={{ margin: '20px' }} />;
    }

    return (
        <div>
            <CandidateHeader 
                candidate={candidate}
                onViewOwnershipHistory={() => setOwnershipLogVisible(true)}
                brandColor={brandColor}
            />

					<CandidateActivitySection
						referrals={candidate.referrals}
					/>

            {candidate.referrals?.some(r => r.ownerships?.length > 0) && (
                <OwnershipHistoryModal
                    visible={ownershipLogVisible}
                    onClose={() => setOwnershipLogVisible(false)}
                    candidate={candidate}
                />
            )}
        </div>
    );
}

export default CandidatePage;